import {IPaylodAction} from '../interfaces/dispatchers/IAction'
import {ISidebar} from '../core/interfaces/reducers'
import SidebarAction from '../core/enums/ActionTypes/SidebarAction'

const initState = {} as ISidebar
const application = (state: ISidebar = initState, action: IPaylodAction): ISidebar => {
  switch (action.type) {
    case SidebarAction.SET_SELECTED:
      return {...state, currentlySelected: action.payload}
    default:
      return state
  }
}
export default application
